import React from "react"

import { DetailPageNavigation } from "@/app-shell/navigation/DetailPageNavigation"

import type { HeaderAction } from "@/contexts/HeaderActionsContext"

interface HeaderActionControlsProps {
  headerAction: HeaderAction | null
}

export const HeaderActionControls: React.FC<HeaderActionControlsProps> = ({
  headerAction,
}) => {
  if (!headerAction) {
    return null
  }

  switch (headerAction.type) {
    case "custom":
      return <>{headerAction.node}</>
    case "detail-navigation":
      return (
        <DetailPageNavigation
          currentIndex={headerAction.currentIndex}
          hasNext={headerAction.hasNext}
          hasPrevious={headerAction.hasPrevious}
          itemLabel={headerAction.itemLabel}
          onNext={headerAction.onNext}
          onPrevious={headerAction.onPrevious}
          totalItems={headerAction.totalItems}
        />
      )
    default:
      return null
  }
}
